import styled from "styled-components";

export const StyledMenubar = styled.div`
nav-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  background-color: rgb(35, 41, 47);
  color: rgb(247, 250, 252);
  min-height: 50px;
  width: 100%;
  padding: 0 30px;
  position: fixed;
  top: 0;
  z-index: 20;
}
.nav-icon {
  margin: 0!important;
  filter: invert(1);
}
.nav-item{
  padding: 6px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
}
span.nav-icon svg {
  filter: invert(0.7);
}
.dfac {
  display: block;
  align-items: center;
}
.dfac .colorBlock {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: block;
}
.right-block .nav-link .df{
  display: block;
  padding: 0;
}
.right-block .text{
  display: flex;
  align-items: center;
  justify-content: center;
}
.nav-wrapper .header-main {
  height: calc(100vh - 60px);
  display: flex;
  flex-direction: column;
}
.icons_wrap {
  flex: 0 0 auto;
}
.headerSectionMenu {
  height: 100vh;
}
.headerWrapMenu .isCompany {
  z-index: 10;
  top:90%!important;
}
.logo{
  text-align:center;
  padding:15px 0;
}
.logo img{
  width: 60%;
}
.dfac .img_wrap{
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
}
.dfac img{
  width: 100%;
  height: 100%;
  object-fit : cover;
  border-radius: 50%;
} 
.play-icon {
  margin-top: 16px;
  cursor:pointer;
}
`;


// WEBPACK FOOTER //
// ./src/pages/common/Menubar/style.ts